import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {FormikHelpers} from "formik";
import {invalidate} from "services/query-client";
import Page from "components/Page";
import {LinkAPIData} from "types/Link";
import LinkForm from '../Form';

function MutateLink() {
    const {id} = useParams()
    const {data: link, isLoading} = useQuery(
        ['links', {id}],
        () => ngage.links.get(Number(id)),
        {enabled: !!id}
    )

    const store = useMutation((data: LinkAPIData) => ngage.links.store(data))
    const update = useMutation((data: LinkAPIData) => ngage.links.update(Number(id), data))

    const {notify} = useNotifications()
    const navigate = useNavigate()

    // Handle form submission
    async function handleSubmit(values: LinkAPIData, {setSubmitting}: FormikHelpers<LinkAPIData>) {
        id? await handleUpdate(values) : await handleStore(values)
        await invalidate('links')

        setSubmitting(false)
        navigate('/links')
    }

    // Handle store mutation
    async function handleStore(values: LinkAPIData) {
        try {
            await store.mutateAsync(values)
            notify("success", "Link Created", `${values.text} has been created`)
        } catch (error) {
            notify("error", "Link Not Created", `${values.text} could not be stored`)
            throw error
        }
    }

    // Handle update mutation
    async function handleUpdate(values: LinkAPIData) {
        try {
            await update.mutateAsync(values)
            notify("success", "Link Updated", `${values.text} has been updated`)
            await invalidate(['links', {id}])
        } catch (error) {
            notify("error", "Link Not Updated", `${values.text} could not be updated`)
            throw error
        }
    }

    // Prepare breadcrumbs
    const newBreadcrumbs = {'App Content': '/', 'Featured': '/', 'Links': '/links', 'New Link': '/links/new'}
    const editBreadcrumbs = {'App Content': '/', 'Featured': '/', 'Links': '/links', 'Edit Link': `/links/${id}/edit`}

    return (
        <Page title={id ? "Edit Link" : "New Link"}
              breadcrumbs={id ? editBreadcrumbs : newBreadcrumbs}
              isLoading={isLoading}>
            <LinkForm link={link} onSubmit={handleSubmit}/>
        </Page>
    );
}

export default MutateLink;